/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingFinderInputRoomPreferenceV2BackfillResultDto } from '../models/HousingFinderInputRoomPreferenceV2BackfillResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingFinderInputRoomPreferenceV2BackfillService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns HousingFinderInputRoomPreferenceV2BackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingHousingFinderInputRoomPreferenceV2BackfillPreviewBackfill(): CancelablePromise<HousingFinderInputRoomPreferenceV2BackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingFinderInputRoomPreferenceV2Backfill/PreviewBackfill',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns HousingFinderInputRoomPreferenceV2BackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingHousingFinderInputRoomPreferenceV2BackfillExecuteBackfill(): CancelablePromise<HousingFinderInputRoomPreferenceV2BackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingFinderInputRoomPreferenceV2Backfill/ExecuteBackfill',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
